export default __webpack_public_path__ + "static/media/mechanic-1.af9b5af2.jpg";